import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { ShareSimulationComponent } from '../../share-simulation/share-simulation.component';

import { SimulationInfo } from '@classes/simulation/simulation-info';
import { SimulationService } from '@services/simulation.service';
import { OriginService } from '@services/origin.service';
import { UiService } from '@services/ui.service';
import { OriginConfig } from '@classes/origin/origin-config';
import { SimulationVisibilityType } from '@enums/simulation-visibility-type.enum';


@Component({
    selector: 'app-simulations-list',
    templateUrl: './simulations-list.component.html',
    styleUrls: ['./simulations-list.component.scss']
})
export class SimulationsListComponent {
    @Input() simulationsList: SimulationInfo[];
    @Input() partitioningCode: string;
    @Input() isActionAllowed: boolean;
    @Input() isAuthorShown: boolean;
    @Input() isCreatedAtShown: boolean;
    @Input() selectedCode: string;

    visibilityType = SimulationVisibilityType;

    constructor(
        private simulationSrv: SimulationService,
        private originSrv: OriginService,
        private uiSrv: UiService,
        private dialog: MatDialog
    ) { }

    isSelected(lineCode: string): boolean {
        return this.selectedCode && lineCode === this.selectedCode;
    }

    onSelectSimu(selSimu: SimulationInfo, isRefresh: boolean = false): void {
        // avoid click on same simu
        if(isRefresh || (selSimu.code !== this.selectedCode)) {
            this.originSrv.set(new OriginConfig({ partitioningCode: this.partitioningCode }), true)
            .subscribe(() => {
                this.simulationSrv.get(selSimu.code, selSimu.to).subscribe();
            });
        }
    }

    onDeleteSimu(simuCode: string): void {
        const message = 'main.dialogs.confirmDeleteSimu.summary';

        this.uiSrv.confirmDialog(message).afterClosed()
        .subscribe((result: boolean) => {
            if(result) {
                this.simulationSrv.delete(simuCode);
            }
        });
    }

    onShareSimu(selSimu: SimulationInfo): void {
        this.dialog.open(ShareSimulationComponent, {
            data: { simuToShare: selSimu }
        });
    }
}
